// Nested reducers
import { vendorsReducer } from "./vendors/vendors.reducer";

// **************************************************************************
// VENDOR REDUCER
// **************************************************************************

export const vendorReducer = [
    ...vendorsReducer,
];
